import { useParams } from 'react-router';
import capitalOneLogo from '@assets/C1.svg';
import { useWorkflow } from '@hooks/useWorkflow';

export const AlternativeWorkflow = () => {
  const { processId } = useParams();

  const { domain, templateJson } = useWorkflow();

  return (
    <div className="brand" data-testid="AlternativeWorkflow">
      <img
        src={capitalOneLogo}
        height="86"
        alt="Capital One"
        role="presentation"
      />
      <h2>the domain returned from useWorkflow is {domain}</h2>
      <pre>
        <code>{JSON.stringify(templateJson, null, 2)}</code>
      </pre>
      <p>processId: {processId}</p>
    </div>
  );
};
